import i18n from '../../../../i18n/config';

export const getCountriesSelectOptions = (): {
  label: string;
  value: string;
}[] => {
  return [
    {
      label: i18n.t('shippingRates.dialogs.countryOptions.usa'),
      value: 'US',
    },
    {
      label: i18n.t('shippingRates.dialogs.countryOptions.canada'),
      value: 'CA',
    },
  ];
};
